import { render, staticRenderFns } from "./OrderItemsTab.vue?vue&type=template&id=2cc9827e&scoped=true&"
import script from "./OrderItemsTab.vue?vue&type=script&lang=js&"
export * from "./OrderItemsTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemsTab.vue?vue&type=style&index=0&id=2cc9827e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9827e",
  null
  
)

export default component.exports